import ItinerariesModule from '@/itineraries/store/itineraries-module'
import AuthModule from '@/users/store/auth-module'

export default {
  AuthModule,
  ItinerariesModule,
}
